import { AssetTypeModel } from '@app/core/models/assets/asset-type.model';
import { ActivableModel } from '@app/core/models/shared/activable.model';

export class AssetModel extends ActivableModel {

  constructor() {
    super();
  }

  public Id: number;
  public Reference: string;
  public TypeId: AssetTypeModel;
  public TypeName: string;
  public OperationalGroupId: number | null;
  public OperationalGroupName: string;
  public RecipientEntityId: number;
  public RecipientEntityName: string;
}
